import Area from '@/components/Area';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import { Perf } from 'r3f-perf';
import * as THREE from 'three';
import { Detailed, Environment, OrbitControls, useGLTF } from '@react-three/drei';
import gl01 from './bust-1-d.glb';
import gl02 from './bust-2-d.glb';
import gl03 from './bust-3-d.glb';
import gl04 from './bust-4-d.glb';
import gl05 from './bust-5-d.glb';

// Create 800 objects with random position and rotation data
const positions = [...Array(800)].map(() => ({
  position: new THREE.Vector3(40 - Math.random() * 80, 40 - Math.random() * 80, 40 - Math.random() * 80),
  rotation: new THREE.Euler(Math.random() * Math.PI * 2, Math.random() * Math.PI * 2, Math.random() * Math.PI * 2),
}));

const LEVEL_OF_DETAILS = [0, 15, 25, 35, 100];

function Bust(props: Omit<React.ComponentProps<typeof Detailed>, 'distances' | 'children'>) {
  const gltfList = useGLTF([gl01, gl02, gl03, gl04, gl05]);
  return (
    <Detailed distances={LEVEL_OF_DETAILS} {...props}>
      {[
        ...gltfList.map(({ nodes, materials }, index) => (
          <mesh
            receiveShadow
            castShadow
            key={index}
            // @ts-ignore
            geometry={nodes.Mesh_0001.geometry}
            material={materials.default}
            material-envMapIntensity={0.25}
          />
        )),
      ]}
    </Detailed>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  const [showPerf, setShowPerf] = React.useState(false);

  return (
    <>
      <Area>
        {() => (
          <div className="relative w-full h-full">
            <Canvas css={{ width: '100%', height: '100%' }}>
              <ambientLight intensity={1} />
              {/* <pointLight position={[0, 0, 0]} intensity={0.5} />
          <spotLight intensity={2.5} position={[50, 50, 50]} castShadow /> */}
              {showPerf && <Perf position="top-right" />}
              {/* <R3fInfo /> */}
              {positions.map(({ position, rotation }, i) => (
                <Bust key={i} {...props} position={position} rotation={rotation} />
              ))}
              <OrbitControls />
              <Environment preset="city" />
              <axesHelper args={[100]} />
            </Canvas>
            <div className="absolute bottom-0 right-0 p-1 bg-white flex">
              <input
                checked={showPerf}
                readOnly
                type="checkbox"
                id="toggleHelper"
                // className="peer hidden"
                onClick={() => {
                  setShowPerf(!showPerf);
                }}
              />
              <label htmlFor="toggleHelper" className="cursor-pointer ml-1">
                Toggle Perf
              </label>
            </div>
          </div>
        )}
      </Area>
    </>
  );
}

export default React.memo(App01);
